export default __webpack_public_path__ + "static/media/freespins.cc15ddf0.svg";